import { PaginationState } from '@kubit/web-ui-components/pagination/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { commonPageContainer, commonStyles } from '../commonStyles';
import { PaginationVariantType } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [PaginationVariantType.REGULAR]: {
            ...commonStyles(FOUNDATIONS, {}),
            [PaginationState.DEFAULT]: {
                pageContainer: {
                    ...commonPageContainer(FOUNDATIONS, {}),
                },
                page: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_regular,
                },
            },
            [PaginationState.SELECTED]: {
                pageContainer: {
                    ...commonPageContainer(FOUNDATIONS, {
                        background_color: FOUNDATIONS.color_comp_navigation_pagination_selected_icon,
                        border_radius: FOUNDATIONS.radius_1000,
                    }),
                },
                page: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_400,
                    color: FOUNDATIONS.color_comp_navigation_pagination_selected_font,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map